module.exports = __webpack_public_path__ + "img/logo.a640f438.svg";